/* eslint-disable no-undef */
export default function () {
  const widgetName = 'timeWidget';
  const widgetOpts = timeWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data) {
      $('#timeWidget').remove();
      const time = data.items[0].Title;
      const timeSpan = `<span class="time">·&nbsp;&nbsp;${time}</span>`;
      // check if body has not class siteInfoBannerWidgetDateIsPast
      // if it does not have the class, append the timeSpan

      if (
        $('#siteInfoBannerWidget').length &&
        !$('body').hasClass('siteInfoBannerWidgetDateIsPast')
      ) {
        $('#siteInfoBannerWidget #eventDates').append(timeSpan);
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
